import { additionalInfoMapping, AdditionlInfoFilterInfo, initialScientificAnalysisFilterPanelSelectEntityState, ScientificAnalysisFilterPanelSelectEntityState } from '@/modules/scientific-analysis-module/components/scientific-analysis-filter-panel-selectentity/scientific-analysis-filter-panel-selectentity.models'
import { ScientificAnalysisConditionComponent, ScientificAnalysisStaticImplements } from '@/modules/scientific-analysis-module/components/scientific-analysis-filter-panel/scientific-analysis-filter-panel-conditionfactory'
import { ScientificAnalysisSelectedFilter } from '@/modules/scientific-analysis-module/scientific-analysis-module.models'
import { ScientificAnalysisComparatorType, ScientificAnalysisConditionTypeEnum, ScientificAnalysisFieldAdditionalInfo, SimpleListEntity, SimpleListEntityResponse } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'
import { scientificAnalysisService } from '@/modules/scientific-analysis-module/services/scientific-analysis-services'
import { ScientificAnalysisComparisonType, ScientificAnalysisCondition, ScientificAnalysisConditionValidationErrorCode } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component({
    components: {}
})
// eslint-disable-next-line no-use-before-define
@ScientificAnalysisStaticImplements<ScientificAnalysisConditionComponent<ScientificAnalysisFilterPanelSelectentity>>()
export default class ScientificAnalysisFilterPanelSelectentity extends Vue {
    state: ScientificAnalysisFilterPanelSelectEntityState
    static COMPONENT_NAME = 'scientific-analysis-filter-panel-selectentity'
    static ALLOWED_COMPARATORS: ScientificAnalysisComparatorType[] = [
        ScientificAnalysisComparatorType.EQUALS,
        ScientificAnalysisComparatorType.NOT_EQUAL,
        ScientificAnalysisComparatorType.EQUALS_ALL
    ]
    @Prop() condition!: ScientificAnalysisCondition
    @Prop() selectedFilter!: ScientificAnalysisSelectedFilter

    constructor() {
        super()
        this.state = initialScientificAnalysisFilterPanelSelectEntityState()
    }

    get isMultipleEntity(): boolean {
        return this.condition.comparisonType.conditionType === ScientificAnalysisConditionTypeEnum.SET
    }

    static canAccept(comparisonType: ScientificAnalysisComparisonType): boolean {
        return !!comparisonType.additionalInfo && comparisonType.additionalInfo !== null &&
            comparisonType.additionalInfo !== ScientificAnalysisFieldAdditionalInfo.selectPatientIdentifier &&
            ScientificAnalysisFilterPanelSelectentity.ALLOWED_COMPARATORS.includes(comparisonType.comparatorType)
    }

    async loadSimpleEntityInfo(filter: Nullable<string>): Promise<SimpleListEntityResponse[]> {
        let filterInput = filter
        const entityInfo = this.getEntity()
        if (entityInfo.entity === SimpleListEntity.ATTACHMENT_TYPE) {
            filterInput = `${this.selectedFilter.entityFilters.entityType}.${filter || ''}`
        }
        this.state.asyncSearch = entityInfo.async
        this.state.entities = await scientificAnalysisService.getEntitySimpleList(entityInfo.entity, filterInput)

        // in the concrete case of selectCodification, it is needed to perform 2 queries (morphologic + topographic) and join them
        if (this.condition.comparisonType.additionalInfo === ScientificAnalysisFieldAdditionalInfo.selectCodification) {
            const topographicEntities = await scientificAnalysisService.getEntitySimpleList(SimpleListEntity.TOPOGRAPHIC_CODE, filterInput)
            this.state.entities = this.state.entities.concat(topographicEntities)
        }

        return this.state.entities
    }

    onSelect(entity: SimpleListEntityResponse | SimpleListEntityResponse[]): void {
        if (Array.isArray(entity)) {
            this.condition.value = entity.map((entityItem) => entityItem.id)
            this.condition.valueTo = entity.map((entityItem) => entityItem.label)
        } else {
            this.condition.value = entity.id
            this.condition.valueTo = entity.label
        }
        this.onChange()
    }

    get selectedEntity(): StrictNullable<SimpleListEntityResponse | SimpleListEntityResponse[]> {
        if (Array.isArray(this.condition.value) && Array.isArray(this.condition.valueTo)) {
            return this.condition.value.map((item, indexItem) => {
                return {
                    id: item,
                    label: this.condition.valueTo ? this.condition.valueTo[indexItem] : ''
                }
            })
        } else if (this.condition.value && this.condition.valueTo) {
            return {
                id: this.condition.value as string,
                label: this.condition.valueTo as string
            }
        } else {
            return null
        }
    }

    private getEntity(): AdditionlInfoFilterInfo {
        if (this.condition.comparisonType.additionalInfo !== null) {
            let entityInfo: AdditionlInfoFilterInfo | null = additionalInfoMapping[this.condition.comparisonType.additionalInfo]
            if (entityInfo) {
                return entityInfo
            } else {
                throw new Error(`Additional Info '${this.condition.comparisonType.additionalInfo}' not implemented!`)
            }
        }
        throw new Error(`No additionalInfo selected!!`)
    }

    get _validate(): boolean {
        if (this.condition.value.length === 0) {
            this.condition.validationErrorCode = ScientificAnalysisConditionValidationErrorCode.EMPTY
        } else {
            this.condition.validationErrorCode = ScientificAnalysisConditionValidationErrorCode.NONE
        }
        return this.condition.validationErrorCode !== ScientificAnalysisConditionValidationErrorCode.NONE
    }

    @Emit('modification')
    private onChange():void { }
}
